import React, { useState } from "react";
import { TableBody } from "@mui/material";

import WorkOrderRoutingEditRow from "./WorkOrderRoutingEditRow";
import WorkOrderRoutingRow from "./WorkOrderRoutingRow";

const WorkOrderRoutingTableBody = ({
  fields = [],
  editId,
  setRouteId = () => {},
  setEditId = () => {},
  showCompleted = false,
  showQuantity = false,
}) => {
  const [open, setOpen] = useState(new Set());

  const handleRowClick = (id) => {
    setOpen((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const filtered = showCompleted
    ? fields
    : fields?.filter((item) => !item?.endDate);

  return (
    <TableBody>
      {filtered?.map(({ prefix, ...item }, idx) => {
        const key = item.id;
        const props = {
          key,
          idx,
          item,
          open,
          handleRowClick,
          setRouteId,
          setEditId,
          showQuantity,
          prefix,
        };
        const RowComponent =
          editId === item.id ? WorkOrderRoutingRow : WorkOrderRoutingEditRow;
        return <RowComponent {...props} />;
      })}
    </TableBody>
  );
};

export default WorkOrderRoutingTableBody;
